<div class="modal-header">
  <div class="modal-title">
    @if (confirmTone === 'danger') {
      <i
        class="bi bi-exclamation-triangle confirm-icon confirm-icon--danger"
      ></i>
    } @else {
      <i class="bi bi-question-circle confirm-icon"></i>
    }
    <h3 class="mb-0">{{ title }}</h3>
  </div>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="cancel()"
  ></button>
</div>

<div class="modal-body">
  <!--
    Keeps `mb-0` unless something follows it. 64 call sites use this modal and
    one passes the new inputs, so dropping the class outright added bottom
    margin to 63 existing dialogs that gained nothing for it.
  -->
  <p
    class="confirm-text whitespace-prewrap"
    [class.mb-0]="!consequenceText && !acknowledgementText"
  >
    {{ displayText }}
  </p>

  <!--
    Its own alert rather than another paragraph: this is what the action costs
    someone else, and it is the sentence most likely to be skimmed.
  -->
  @if (consequenceText) {
    <div class="alert alert-warning mb-0">{{ consequenceText }}</div>
  }

  @if (acknowledgementText) {
    <div class="form-check mt-3 mb-0">
      <input
        id="confirm-acknowledgement"
        type="checkbox"
        class="form-check-input"
        [(ngModel)]="acknowledged"
      />
      <label class="form-check-label" for="confirm-acknowledgement">
        {{ acknowledgementText }}
      </label>
    </div>
  }
</div>

<div class="modal-footer">
  <div class="action-row justify-end w-100">
    @if (!hideCancelButton) {
      <button type="button" class="btn btn-ghost" (click)="cancel()">
        {{ cancelButtonText }}
      </button>
    }
    <button
      type="button"
      class="btn"
      [class.btn-primary]="confirmTone === 'primary'"
      [class.btn-danger]="confirmTone === 'danger'"
      [disabled]="!canContinue"
      (click)="continue()"
    >
      {{ continueButtonText }}
    </button>
  </div>
</div>
